import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { STATUS_LABEL, STATUS_HEX } from "@/lib/constants";

const StatusContext = createContext({ statuses: [], reasons: [], koReasons: [], reload: () => {} });

export function StatusProvider({ children }) {
  const { user } = useAuth();
  const [statuses, setStatuses] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [koReasons, setKoReasons] = useState([]);

  const reload = useCallback(() => {
    api.get("/ticket-statuses").then((r) => setStatuses(r.data)).catch(() => {});
    api.get("/motivi-sospensione").then((r) => setReasons(r.data)).catch(() => {});
    api.get("/motivi-ko").then((r) => setKoReasons(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (user) reload();
    else { setStatuses([]); setReasons([]); setKoReasons([]); }
  }, [user, reload]);

  return (
    <StatusContext.Provider value={{ statuses, reasons, koReasons, reload }}>
      {children}
    </StatusContext.Provider>
  );
}

export const useStatuses = () => {
  const { statuses, reasons, koReasons, reload } = useContext(StatusContext);
  const options = statuses.length
    ? statuses.map((s) => ({ v: s.key, l: s.label, color: s.color, fixed: s.fixed }))
    : Object.entries(STATUS_LABEL).map(([v, l]) => ({ v, l, color: STATUS_HEX[v], fixed: false }));
  const labelOf = (key) => {
    const s = statuses.find((x) => x.key === key);
    return s ? s.label : (STATUS_LABEL[key] || key || "—");
  };
  const hexOf = (key) => {
    const s = statuses.find((x) => x.key === key);
    return (s && s.color) || STATUS_HEX[key] || "#64748b";
  };
  return { statuses, options, reasons, koReasons, reload, labelOf, hexOf };
};
